import axios from '../utils/axios'

// export function SAppShortInfo (params) {
//   return axios({
//     url: '/Member/SApp/SAppShortInfo',
//     method: 'get',
//     params: params
//   })
// }

// export function UserRegister (data = {}) {
//   return axios({
//     url: '/WechatService/Register',
//     method: 'post',
//     data: data
//   })
// }

// 获取注销申请数据接口
export function GetLogoutApplyForStatus(params) {
  return axios({
    url: '/Member/LogoutApplyFor/GetLogoutApplyForStatus',
    method: 'get',
    params: params
  })
}

// 发送注销确认验证码接口
export function GetTelCode(data = {}) {
  return axios({
    url: '/Member/LogoutApplyFor/GetTelCode',
    method: 'post',
    data: data
  })
}

// 校验注销确认验证码接口
export function CodeAvailable(data = {}) {
  return axios({
    url: '/Member/LogoutApplyFor/CodeAvailable',
    method: 'post',
    data: data
  })
}

// 账号注销申请接口
export function ApplyFor(data = {}) {
  return axios({
    url: '/Member/LogoutApplyFor/ApplyFor',
    method: 'post',
    data: data
  })
}

// 账号注销取消申请接口
export function LogoutCancel(data = {}) {
  return axios({
    url: '/Member/LogoutApplyFor/LogoutCancel',
    method: 'post',
    data: data
  })
}
